import React from 'react';
import { Star } from 'lucide-react';
import { Card } from './ui/Card';
const testimonials = [{
  quote: 'The online classes were incredibly easy to navigate. I finished my renewal over the weekend without any technical headaches.',
  author: 'Sarah Jenkins',
  role: 'Associate Broker, Scottsdale'
}, {
  quote: "I've been using Desert Sage for 8 years now. The content is actually relevant to our market, not just generic fluff.",
  author: 'Michael Rodriguez',
  role: 'Realtor®, Phoenix'
}, {
  quote: "Love the Zoom classes! It feels like being in a classroom but I don't have to drive across town. Instructors are top notch.",
  author: 'Jennifer Wu',
  role: 'Sales Agent, Mesa'
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-174">
            Trusted by Arizona Agents
          </h2>
          <div className="flex justify-center space-x-1 mb-4" data-id="element-175">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-brand-orange-400 fill-current" data-id="element-176" />)}
          </div>
          <p className="text-gray-600" data-id="element-177">
            Join thousands of satisfied professionals who renew with us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          {testimonials.map((item, index) => <Card key={index} className="p-8 bg-gray-50 border-none" data-id="element-179">
              <div className="flex mb-4" data-id="element-180">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-orange-400 fill-current" data-id="element-181" />)}
              </div>
              <blockquote className="text-gray-700 mb-6 leading-relaxed" data-id="element-182">
                "{item.quote}"
              </blockquote>
              <div data-id="element-183">
                <div className="font-bold text-gray-900" data-id="element-184">{item.author}</div>
                <div className="text-sm text-brand-purple-600" data-id="element-185">{item.role}</div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}